module.exports = __webpack_public_path__ + "img/bbet-placeholder1.69304ab3c1b892afe3d48b6659bf0660.jpg";